/*eslint-disable*/

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { toast } from 'react-toastify';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import axios from 'axios';
import Key from '../../../clientVariables.json';
import { DialogActions, DialogContent, DialogTitle, TextField, Stack, Chip, InputAdornment, Tooltip } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SendIcon from '@mui/icons-material/Send';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SendMailContract({ isOpen }) {
  //console.log("isOpen", isOpen.contractData.email)
  const [open, setOpen] = React.useState(false);
  const [pdfUrl, setPdfUrl] = React.useState(null);
  const [openMail, setOpenMail] = React.useState(false)
  const [ccInput, setCcInput] = React.useState('');

  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const parseEmails = (input) => {
    if (!input) return [];
    const parts = input
      .split(/[\s,;]+/)
      .map((e) => e.trim())
      .filter(Boolean);

    const unique = Array.from(new Set(parts.map((e) => e.toLowerCase())));
    const valid = unique.filter(isValidEmail);
    if (unique.length > 0 && valid.length !== unique.length) {
      toast.warn('Some CC emails were invalid and ignored.');
    }
    return valid;
  };

  const handleView = async () => {
    const customerId = isOpen.contractData?.customer_id;
    const fileName = isOpen.invoiceData?.contract_filename;
    console.log("isOpen", isOpen);
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/${customerId}/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      setPdfUrl(url);
      setOpen(true);
    } catch (error) {
      console.error('Error viewing file:', error);
      toast.error("Something went wrong try again..!");
      //   if(!selectedCustomerDetails){
      //     toast.error("Select Customer")
      //   }else if(!selectedCustomerDetails?.file_name){
      //     toast.error("Create Agreement");
      //   }
    }
  };

  React.useEffect(() => {
    if (isOpen.isOpen) {
      handleClickOpen();
      handleView();

    }
  }, [isOpen]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendMailHandler = async () => {
    const cc_emails = parseEmails(ccInput);

    try {
      const response = await axios.post(`${Key.domain}/payment/mail/send_contract`, {
        invoice_number: isOpen.invoiceData.invoice_no,
        cc_emails
      });
      if (response.status === 200) {
        toast.success("Mail Sent..!");
        setOpenMail(false);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong try again..!");
    }
  }

  const openMailPopup = () => {
    setOpenMail(true)
  }

  const toEmail    = isOpen?.contractData?.email ?? "";

  return (
    <React.Fragment>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open full-screen dialog
      </Button> */}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Subscription Service Agreement
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={sendMailHandler}> */}
            <Button autoFocus color="inherit" onClick={openMailPopup}>
              Send Mail
            </Button>
          </Toolbar>
        </AppBar>
        <Box sx={{ width: '80vw', height: '80vh', overflow: 'auto', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          {pdfUrl ? (
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}
            //  workerUrl={`https://unpkg.com/pdfjs-dist@${window['pdfjs-dist/build/pdf'].version}/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl={pdfUrl} />
            </Worker>
          ) : (
            <p>Loading...</p>
          )}
          <Button variant="contained" onClick={handleClose} sx={{ position: 'absolute', bottom: '20px' }}>Close</Button>
        </Box>
        {/* <List>
          <ListItemButton>
            <ListItemText primary="Phone ringtone" secondary="Titania" />
          </ListItemButton>
          <Divider />
          <ListItemButton>
            <ListItemText
              primary="Default notification ringtone"
              secondary="Tethys"
            />
          </ListItemButton>
        </List> */}
      </Dialog>
      <Dialog open={openMail} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MailOutlineIcon fontSize="small" />
            Send email
          </Box>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="To Email"
            placeholder="to Email"
            value={toEmail}
            size="small"
            margin="dense"
            disabled
            fullWidth
          />
          <TextField
            label="CC recipients"
            placeholder="Type emails separated by comma, space, or semicolon"
            value={ccInput}
            onChange={(e) => setCcInput(e.target.value)}
            fullWidth
            size="small"
            margin="dense"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Tooltip title="Add multiple recipients">
                    <GroupsOutlinedIcon fontSize="small" />
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />

          {(() => {
            const tokens = (ccInput || '')
              .split(/[\s,;]+/)
              .map((t) => t.trim())
              .filter(Boolean);
            const deduped = Array.from(new Set(tokens.map((t) => t.toLowerCase())));
            const valid = deduped.filter((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
            const invalid = deduped.filter((e) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
            return deduped.length > 0 ? (
              <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
                {valid.map((email) => (
                  <Chip key={email} label={email} size="small" variant="outlined" />
                ))}
                {invalid.map((email) => (
                  <Chip key={`inv-${email}`} label={email} size="small" color="error" variant="outlined" />
                ))}
              </Stack>
            ) : null;
          })()}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenMail(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={sendMailHandler} variant="contained" startIcon={<SendIcon />}>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
